export const NOISE_MODELS_MAP = {
  harmony: "Harmony noise model",
  "aria-1": "Aria 1 noise model",
  "aria-2": "Aria 2 noise model",
  baritone: "Baritone noise model",
  forte: "Forte noise model",
  "forte-1": "Forte-1 noise model"
};
